define('app/views/templates/helpers/nl2br',['Handlebars','showdown'], function ( Handlebars, showdown ){
    function nl2br(value) {
        return (new showdown.Converter()).makeHtml(String(value))
            // .replace(/\r?\n/g, '<br/>')
            /*.replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&apos;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');*/

    }


    Handlebars.registerHelper( 'nl2br', nl2br );
    return nl2br;
});


